<template>
  <section class="av-feat" aria-labelledby="avaluos-features-title">
    <h2 id="avaluos-features-title" class="wd-title">
      <span class="hl">Características</span> <span class="av-feat__base">generales</span>
    </h2>

    <ul class="av-feat__grid">
      <li v-for="feature in features" :key="feature.title" class="av-feat__card">
        <div class="av-feat__head">
          <img :src="feature.icon" alt="" aria-hidden="true">
          <h3 class="av-feat__title" v-html="feature.title" />
        </div>
        <p class="wd-body" v-html="feature.description" />
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import queEsIcon from '../../../assets/avaluos-figma/ic-que-es.svg'
import vigenciaIcon from '../../../assets/avaluos-figma/ic-vigencia.svg'
import plazoIcon from '../../../assets/avaluos-figma/ic-plazo.svg'

const features = [
  {
    icon: queEsIcon,
    title: '¿Qué es y <br class="br-d">para <br class="br-t">qué sirve?',
    description: 'Es un documento que establece el valor de un bien inmueble mediante una investigación y análisis de mercado, a partir de sus características físicas, ubicación y uso.'
  },
  {
    icon: vigenciaIcon,
    title: 'Vigencia',
    description: 'Tiene una vigencia de <br class="br-d">6 meses <br class="br-tm">a partir de la fecha <br class="br-d">de emisión, <br class="br-tm">por lo que es importante realizarlo de <br class="br-d">manera oportuna.'
  },
  {
    icon: plazoIcon,
    title: 'Plazo de entrega',
    description: '<strong>4 días hábiles</strong> posterior a la visita del perito al inmueble'
  }
]
</script>

<style scoped>
.av-feat { display: flex; flex-direction: column; gap: var(--ds-space-7); }
.av-feat__base { color: var(--ds-purple-900); }
.av-feat .wd-title { height: 40px; line-height: 44px; }

.av-feat__grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: var(--ds-space-5);
  margin: 0;
  padding: 0;
  list-style: none;
}
.av-feat__card { grid-column: span 2; }

.av-feat__card {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-4);
  /* El borde de 1px va dentro de las medidas del Figma (24px de padding incluyendo el trazo) */
  padding: calc(var(--ds-space-5) - 1px);
  box-sizing: border-box;
  background: var(--ds-grey-50);
  border: 1px solid var(--ds-border-card);
  border-radius: 16px;
}

.av-feat__head { display: flex; align-items: center; gap: var(--ds-space-4); }
.av-feat__head img { flex: 0 0 40px; width: 40px; height: 40px; }
.av-feat__title {
  margin: 0;
  color: var(--ds-text-body);
  font-size: 18px;
  font-weight: 600;
  line-height: normal;
}
.av-feat__card :deep(strong) { font-weight: 700; }

@media (max-width: 1024px) {
  .av-feat__grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .av-feat__card { grid-column: auto; }
}

/* En tablet la tercera card mide 248px de alto en el Figma */
@media (min-width: 600px) and (max-width: 1024px) {
  .av-feat__card:last-child { min-height: 248px; }
}

@media (max-width: 599px) {
  .av-feat { gap: var(--ds-space-6); }
  .av-feat__grid { grid-template-columns: minmax(0, 1fr); gap: var(--ds-space-4); }
  .av-feat__title { white-space: nowrap; }
}
</style>
